import { render, staticRenderFns } from "./DatabaseManagement.vue?vue&type=template&id=15ba8065"
import script from "./DatabaseManagement.vue?vue&type=script&lang=js"
export * from "./DatabaseManagement.vue?vue&type=script&lang=js"
import style0 from "./DatabaseManagement.vue?vue&type=style&index=0&id=15ba8065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports